module.exports = __webpack_public_path__ + "static/img/school-7.bc367bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-7.png
// module id = CffV
// module chunks = 1